module.exports = __webpack_public_path__ + "media/components/Influencers/Oauths/New/StepPage/check_icon-7e944e9525ce1dddbf29324732d78b73.svg";